/**
 * Adapter: keep Atlas `av-btn` API while chrome geometry comes from nedi-ui-web.
 * Prefer this for new controls; existing className buttons keep working via
 * Buttons.css token aliases during the migration cycle.
 *
 * Only CE contract attrs are forwarded — React a11y/data props on formAssociated
 * `<nedi-button>` throw in jsdom (`Unexpected attributes`).
 */
import { createElement } from 'react'

const VARIANT_MAP = {
  primary: 'primary',
  secondary: 'secondary',
  ghost: 'ghost',
  destructive: 'destructive',
  danger: 'destructive',
  icon: 'icon',
  tinted: 'tinted',
}

export default function AvButton({
  variant = 'primary',
  type = 'button',
  disabled = false,
  loading = false,
  block = false,
  className = '',
  children,
  onClick,
}) {
  const nediVariant = VARIANT_MAP[variant] || 'primary'
  const attrs = {
    variant: nediVariant,
    type,
    class: ['av-nedi-btn', className].filter(Boolean).join(' '),
    onClick,
  }
  if (disabled || loading) attrs.disabled = ''
  if (block) attrs.block = ''
  if (loading) attrs.loading = ''
  return createElement('nedi-button', attrs, children)
}
